import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getDataDefinitions } from "../../../api/geoReportingApi";

const GeoReportingDataDefinitions = () => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ["geo-reporting-data-definitions"],
        queryFn: getDataDefinitions,
    });

    return (
        <div className="data_documentation">
            <h3>DATA DEFINITIONS - DATA OVERVIEW</h3>

            <br />

            <table className="docs_table">
                <thead>
                    <tr>
                        <th>KPI</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading && (
                        <tr>
                            <td colSpan={2}>Loading...</td>
                        </tr>
                    )}
                    {isError && (
                        <tr>
                            <td colSpan={2}>Failed to load data definitions.</td>
                        </tr>
                    )}
                    {Array.isArray(data) && data.map((dataItem: { KPI: string; Description: string }, index: number) => (
                        <tr key={index}>
                            <td>{dataItem.KPI}</td>
                            <td>{dataItem.Description}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
            <br />
        </div>
    );
};

export default GeoReportingDataDefinitions;